export default __webpack_public_path__ + "static/media/incognito.b111b765.svg";